import React from 'react'
import { SafeAreaProvider } from 'react-native-safe-area-context'

import  InApp from './Migration'

function Migration(props){
    return <SafeAreaProvider>
        <InApp {...props} />
    </SafeAreaProvider>
}
export { Migration }
